export default __webpack_public_path__ + "static/media/icon585white.ee1f9be8.svg";